export function isDevEnv() {
    return process.env.APP_ENV === 'DEV'
}



// WEBPACK FOOTER //
// ./src/helpers/is-dev-env.js